import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent implements OnInit {

  @Input() control: UntypedFormControl = null;
  @Input() inline: boolean;
  @Input() label: string;

  constructor(
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  get errors(): string {
    if (this.control.invalid && this.control.errors) {
      const errors = [];
      for (const [key, value] of Object.entries(this.control.errors)) {
        switch (key) {
          case('required'): {
            if (value === true) {
              errors.push((this.label) ? this.transloco.translate('common.errors.mandatory_value', { value: this.label }) : this.transloco.translate('common.errors.mandatory'));
            }
            break;
          }
          case('email'): {
            errors.push(this.transloco.translate('common.errors.wrong_email'));
            break;
          }
          case('min'): {
            errors.push(this.transloco.translate('common.errors.min', { value: value.min }));
            break;
          }
          case('max'): {
            errors.push(this.transloco.translate('common.errors.max', { value: value.max }));
            break;
          }
          case('minlength'): {
            errors.push(this.transloco.translate('common.errors.minlength', { value: value.requiredLength }));
            break;
          }
          case('minMax'): {
            errors.push(this.transloco.translate('common.errors.minmax'));
            break;
          }
          case('passwordLength'): {
            errors.push(this.transloco.translate('common.errors.password_length'));
            break;
          }
          case('passwordStrength'): {
            errors.push(this.transloco.translate('common.errors.password_strength'));
            break;
          }
          case('passwordMatch'): {
            errors.push(this.transloco.translate('common.errors.password_match'));
            break;
          }
          case('wrongUrl'): {
            errors.push(this.transloco.translate('common.errors.url_format'));
            break;
          }
          case('wrongPhone'): {
            errors.push(this.transloco.translate('common.errors.phone_format'));
            break;
          }
          case('positiveNumber'): {
            errors.push(this.transloco.translate('common.errors.positive_numeric_value'));
            break;
          }
          default: {
            if (key.match(/backend/) && value.messages) {
              value.messages.forEach((message: string) => {
                errors.push(this.transloco.translate(message));
              });
            } else if (this.label) {
              errors.push(this.label);
            } else {
              errors.push(this.transloco.translate('common.errors.unknown'));
            }
            break;
          }
        }
      }
      return errors.join('\n');
    }
    return '';
  }

}
